import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreForm } from '@types';

const useGetForm = () => {
    const data = useStaticQuery(graphql`
        query AllForm {
            allPatstoreForm {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    date
    state
    form_fields
    
                    }
                }
            }
        }
    
        `);


    const allForm: PatstoreForm[] =
        data.allPatstoreForm.edges.map(
            (edge: { node: PatstoreForm }) => edge.node
        ) || [];

    const findForm: (id: string) => PatstoreForm | undefined = (id: string) => {
        const result = allForm.find((item: PatstoreForm) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findForm,
        forms: allForm,
    };
}; 

export default useGetForm;
